export default function (app) {
  app.config([
    '$translateProvider',
    'config',
    function ($translateProvider, config) {
      $translateProvider.registerAvailableLanguageKeys(['en'], {
        'en_*': 'en',
        '*': 'en',
      });
      $translateProvider.determinePreferredLanguage();
      $translateProvider.useSanitizeValueStrategy('escape');
      $translateProvider.useUrlLoader(`/api/translation`);
    },
  ]);
}
